import React, { useState, useEffect } from 'react';
import {
  Box,
  Flex,
  Input,
  Select,
  InputGroup,
  InputLeftElement
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { useRecoilValue } from 'recoil';
import { topicsAtom } from '../../state/filterAtom';

const MEDIA_TYPES = [
  { value: 'all', label: 'ALL MEDIA TYPES' },
  { value: 'video', label: 'Video' },
  { value: 'social', label: 'Social' },
  { value: 'print', label: 'Print' },
  { value: 'digital', label: 'Digital' }
];

const ITEMS_PER_PAGE = [
  { value: 3, label: '3' },
  { value: 6, label: '6' },
  { value: 12, label: '12' },
  { value: 24, label: '24' },
  { value: 48, label: '48' },
  { value: 96, label: '96' }
];

export const FilterBar = ({ filters, onFilterChange }) => {
  const topics = useRecoilValue(topicsAtom);
  const [searchInput, setSearchInput] = useState(filters.search || '');

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchInput !== filters.search) {
        onFilterChange({ search: searchInput });
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [searchInput, filters.search, onFilterChange]);

  return (
    <Box py={3} px={{ base: 4, md: 8 }} bg="brand.ltGray2">
      <Flex
        direction={{ base: 'column', md: 'row' }}
        gap={4}
        maxW="1400px"
        mx="auto"
        align={{ base: 'stretch', md: 'center' }}
      >
        <InputGroup maxW={{ base: '100%', md: '300px' }}>
          <InputLeftElement pointerEvents="none">
            <SearchIcon color="brand.dkGray1" />
          </InputLeftElement>
          <Input
            placeholder="Search media..."
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            bg="brand.white"
            borderColor="brand.dkGray1"
            _focus={{ borderColor: 'brand.ltRed' }}
          />
        </InputGroup>

        <Select
          value={filters.topic}
          onChange={(e) => onFilterChange({ topic: e.target.value })}
          bg="brand.white"
          borderColor="brand.dkGray1"
          maxW={{ base: '100%', md: '200px' }}
          _focus={{ borderColor: 'brand.ltRed' }}
        >
          <option value="all">ALL TOPICS</option>
          {topics.map((topic) => (
            <option key={topic.id} value={topic.id}>
              {topic.name}
            </option>
          ))}
        </Select>

        <Select
          value={filters.type}
          onChange={(e) => onFilterChange({ type: e.target.value })}
          bg="brand.white"
          borderColor="brand.dkGray1"
          maxW={{ base: '100%', md: '200px' }}
          _focus={{ borderColor: 'brand.ltRed' }}
        >
          {MEDIA_TYPES.map((type) => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </Select>

        <Flex align="center" gap={2} ml={{ base: 0, md: 'auto' }}>
          <Box as="span" fontSize="sm" color="brand.black" whiteSpace="nowrap">
            ITEMS PER PAGE
          </Box>
          <Select
            value={filters.limit}
            onChange={(e) => onFilterChange({ limit: parseInt(e.target.value) })}
            bg="brand.white"
            borderColor="brand.dkGray1"
            w="80px"
            _focus={{ borderColor: 'brand.ltRed' }}
          >
            {ITEMS_PER_PAGE.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </Select>
        </Flex>
      </Flex>
    </Box>
  );
};
